// This file is just a placeholder for Amplitude events since it has been disabled and Pendo is the new analytics tool.

export default {
    logEvent(name) {
        if (import.meta.env.VITE_ENV !== 'prod') {
            console.warn(`"DEPRECATION WARNING: ${name}" is being used as an Amplitude event. Amplitude has been disabled and Pendo is the new analytics tool. If this data needs to go to Pendo, work with the Pendo COE.`);
        }
    },
};
